// extracted by mini-css-extract-plugin
module.exports = {"contain":"card_contain__g0MQ9","img":"card_img__30IO_","containText":"card_containText__l8E8P","text":"card_text__25e3Y","popu":"card_popu__3_mrU"};